var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMnx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_722_32535)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 18C13.9706 18 18 13.9706 18 9C18 4.02944 13.9706 0 9 0C4.02944 0 0 4.02944 0 9C0 13.9706 4.02944 18 9 18Z",
    fill: "#00ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.36044 15.1796C5.2425 14.8528 2.8125 12.2108 2.8125 9C2.8125 5.78925 5.2425 3.14719 8.36044 2.82037V4.716C7.33758 4.87366 6.40498 5.39237 5.73151 6.17821C5.05803 6.96404 4.68821 7.96506 4.689 9C4.68821 10.0349 5.05803 11.036 5.73151 11.8218C6.40498 12.6076 7.33758 13.1263 8.36044 13.284V15.1796ZM9.58388 2.8125C12.5258 3.08194 14.8731 5.40956 15.1796 8.34581H13.2879C13.1472 7.41996 12.7102 6.56466 12.0424 5.90812C11.3746 5.25158 10.512 4.82916 9.58388 4.70419V2.8125ZM15.1875 9.57206C14.9164 12.5477 12.5527 14.9158 9.58388 15.1875V13.2958C10.5261 13.169 11.4004 12.7357 12.0719 12.0627C12.7434 11.3897 13.1749 10.5145 13.2997 9.57206H15.1875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_722_32535"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMnx);
export default __webpack_public_path__ + "static/media/mnx.7edae5675ebdd98a73cd75fcf43a5c11.svg";
export { ForwardRef as ReactComponent };